module.exports = __webpack_public_path__ + "img/kefu (2).107a66ec.png";